// Hungarian postal-code → settlement lookup. Data: GeoNames CC BY 4.0
// (https://download.geonames.org/export/zip/HU.zip), bundled as JSON.
// Budapest district (I–XXIII, Roman) is derived from digits 2–3 of the
// 4-digit code so we don't duplicate "Budapest" 200+ times in the data.

import data from './huPostalCodes.json';

/**
 * Returns { city, district } for a 4-digit HU postal code, or null if
 * not found. `district` is the Roman-numeral Budapest district (e.g.
 * "XIII") and is null outside the 1xxx range.
 */
export function lookupHuPostalCity(postal) {
  if (postal == null) return null;
  const s = String(postal).trim();
  if (!/^\d{4}$/.test(s)) return null;
  const city = data[s];
  if (!city) return null;
  return { city, district: budapestDistrict(s, city) };
}

function budapestDistrict(postal, city) {
  if (city !== 'Budapest') return null;
  if (postal[0] !== '1') return null;
  const n = Number(postal.slice(1, 3));
  if (!Number.isFinite(n) || n < 1 || n > 23) return null;
  return ROMAN[n] || null;
}

const ROMAN = [
  null, 'I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X',
  'XI', 'XII', 'XIII', 'XIV', 'XV', 'XVI', 'XVII', 'XVIII', 'XIX', 'XX',
  'XXI', 'XXII', 'XXIII',
];
